export enum NotificationType {
  InvitationAccepted = "INVITATION_ACCEPTED",
  InvitationDeclined = "INVITATION_DECLINED",
  WorkspaceWelcome = "WORKSPACE_WELCOME",
  RoleUpdated = "ROLE_UPDATED",
  WorkspaceAccessRemoved = "WORKSPACE_ACCESS_REMOVED",
  PledgeCreated = "PLEDGE_CREATED",
  BudgetSubmittedForReview = "BUDGET_SUBMITTED_FOR_REVIEW",
  BudgetApproved = "BUDGET_APPROVED",
  BudgetReturned = "BUDGET_RETURNED",
  BudgetActivated = "BUDGET_ACTIVATED",
  BudgetClosed = "BUDGET_CLOSED",
  BudgetRestored = "BUDGET_RESTORED",
  FinanceTransactionCancelled = "FINANCE_TRANSACTION_CANCELLED",
  FinanceTransactionVoided = "FINANCE_TRANSACTION_VOIDED",
  /** IBA-158 cross-context transfers: a request needs the receiving context to act. */
  TransferSubmitted = "TRANSFER_SUBMITTED",
  TransferApproved = "TRANSFER_APPROVED",
  TransferRejected = "TRANSFER_REJECTED",
  TransferReversed = "TRANSFER_REVERSED",
  Mentioned = "MENTIONED",
  DepartmentMemberAdded = "DEPARTMENT_MEMBER_ADDED",
  Generic = "GENERIC",
}

export enum NotificationCategory {
  Access = "ACCESS",
  Finance = "FINANCE",
  People = "PEOPLE",
  Activities = "ACTIVITIES",
  Assets = "ASSETS",
  System = "SYSTEM",
  Support = "SUPPORT",
}

export enum NotificationPriority {
  Low = "LOW",
  Normal = "NORMAL",
  High = "HIGH",
  Critical = "CRITICAL",
}

export enum NotificationStatus {
  Unread = "UNREAD",
  Read = "READ",
  Archived = "ARCHIVED",
}

export enum NotificationActionType {
  None = "NONE",
  OpenWorkspace = "OPEN_WORKSPACE",
  OpenPledge = "OPEN_PLEDGE",
  OpenProfile = "OPEN_PROFILE",
  OpenSettings = "OPEN_SETTINGS",
  OpenGenericEntity = "OPEN_GENERIC_ENTITY",
  OpenBudget = "OPEN_BUDGET",
  OpenFinanceTransaction = "OPEN_FINANCE_TRANSACTION",
  OpenFinanceTransfer = "OPEN_FINANCE_TRANSFER",
  OpenDepartment = "OPEN_DEPARTMENT",
  OpenActivity = "OPEN_ACTIVITY",
}

export enum NotificationEntityType {
  Workspace = "WORKSPACE",
  Branch = "BRANCH",
  Invitation = "INVITATION",
  Pledge = "PLEDGE",
  User = "USER",
  Budget = "BUDGET",
  FinanceTransaction = "FINANCE_TRANSACTION",
  FinanceTransfer = "FINANCE_TRANSFER",
  Generic = "GENERIC",
}
